export const LOGIN = '/login';
export const CONNECTWISE_POD = '/pod/connectwise/:psaId';
export const HALO_POD = '/pod/halo/:psaId';
export const FRESH_SERVICE_POD = '/pod/freshservice/:psaId';
export const FRESH_SERVICE_POD_WIDGET = '/widget/freshservice/:psaId';
export const FRESH_SERVICE_FULL_SIZE = '/pod/freshservice/:psaId/fullSize';
export const AUTOTASK_POD = '/pod/autotask/:psaId';
export const AUTOTASK_POD_WIDGET = '/widget/autotask/:psaId';
export const WEB_EXTENSION_POD = '/webExtension/';
export const SERVICE_NOW_POD = '/pod/servicenow/:psaId';

export const DUO_LOGIN = '/duoLogin';
export const EXTERNAL_LOGIN = '/externalLogin';
export const AUTOTASK_POD_FULL_SIZE = '/pod/autotask/:psaId/fullSize';
export const KASEYA_POD = '/pod/kaseya/:psaId';
export const SYNCRO_POD = '/pod/syncro/:psaId';
export const SUPER_OPS_POD = '/pod/superOps/:psaId';
export const ZENDESK_POD = '/pod/zendesk/:psaId';
export const MICROSOFT_365_POD = '/pod/microsoft365/:psaId';
export const IMPORT_INTEGRATION_POD = '/pod/importintegration/:psaId';
